import { Suspense, type ReactNode } from "react";
import { RouteFallback } from "@altek/ui/components/feedback/PageSkeleton";

/**
 * The suspense boundary every route element is wrapped in.
 *
 * Its own file because the route table exports a router rather than a component, and a module
 * that exports both loses fast refresh — every edit to a page would remount the whole tree.
 *
 * The fallback is the same skeleton a page shows while its DATA loads, so a lazily-downloaded
 * chunk and a pending query look identical to the user. Two different waiting states for one
 * wait reads as a flicker.
 */
export function RouteBoundary({ children }: { children: ReactNode }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}
